import { Box } from '@alf/uikit';
import { useComponentConfig, useOtherSettings } from '@namespace/cms';
import {
  FILTER_TYPES,
  MAX_SELECTED_FILTER_ITEMS
} from '../../../../../constants';
import { useLocalSearchFilter } from '../../../../../hooks';
import { usePrepareCategoriesForSearchFilter } from '../../../../../hooks/usePrepareCategoriesForSearchFilter';
import { SingleCategoryItem } from '../../Shared/SingleCategoryItem';
import { FilterCardWithDrawer } from '../FilterCardWithDrawer';

import styles from './index.module.css';

export const GamesSearchCategoriesFilter = ({
  feedName,
  selectedCategories,
  onResetClick,
  onApplyClick: onApplyClickProp,
  isLoading
}) => {
  const { categoryLogos } = useComponentConfig();
  const { default: logoDefault } = categoryLogos || {};
  const { gamesFilterConfig = {} } = useOtherSettings();
  const { maxSelectedCategories = MAX_SELECTED_FILTER_ITEMS } =
    gamesFilterConfig;

  const preparedCategories = usePrepareCategoriesForSearchFilter(feedName);

  const { filter, onFilterItemClick, onReset, wasFilterChanged } =
    useLocalSearchFilter(selectedCategories);

  return preparedCategories?.ids?.length ? (
    <FilterCardWithDrawer
      filterId={FILTER_TYPES.CATEGORIES}
      filterBodyTextKey="web.games.search.filters.categories.notif"
      cardTitleTextKey="web.games.search.filters.categories"
      onResetClick={onResetClick}
      onApplyClick={() => onApplyClickProp(filter)}
      onDrawerCloseClick={onReset}
      selectedQuantity={selectedCategories?.length}
      isLoading={isLoading}
      wasFilterChanged={wasFilterChanged}
      isFilterFilled={!!filter.length}
    >
      <Box className={styles.categoriesWrapper}>
        {preparedCategories?.ids?.map((categoryName) => {
          const categoryData = preparedCategories.data[categoryName];
          const categoryDataPrepared = {
            ...categoryData,
            logo: categoryData.logo || logoDefault
          };
          const isActive = filter?.includes(categoryDataPrepared.id);
          const isDisabled =
            !isActive && filter.length >= maxSelectedCategories;
          return (
            <SingleCategoryItem
              key={categoryDataPrepared.id}
              onFilterItemClick={onFilterItemClick}
              categoryData={categoryDataPrepared}
              isActive={isActive}
              isDisabled={isDisabled}
            />
          );
        })}
      </Box>
    </FilterCardWithDrawer>
  ) : null;
};
